import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'sku-add-menu-modal--heading',
    defaultMessage: 'Add menu',
  },
  menuNameLabel: {
    id: 'sku-add-menu-modal--menu-name-label',
    defaultMessage: 'Menu name',
  },
  required: {
    id: 'sku-add-menu-modal--required',
    defaultMessage: 'Required',
  },
  placeholder: {
    id: 'sku-add-menu-modal--placeholder',
    defaultMessage: 'E.g. "Breakfast"',
  },
  nameRequired: {
    id: 'sku-add-menu-modal--name-required',
    defaultMessage: 'Menu name is required.',
  },
  cancel: {
    id: 'sku-add-menu-modal--cancel',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'sku-add-menu-modal--submit',
    defaultMessage: 'Add menu',
  },
  closeAriaLabel: {
    id: 'sku-add-menu-modal--close-aria-label',
    defaultMessage: 'Close',
  },
  addTimeRangeAriaLabel: {
    id: 'sku-add-menu-modal--add-time-range-aria-label',
    defaultMessage: 'Add {dayLabel} time range',
  },
  removeTimeRangeAriaLabel: {
    id: 'sku-add-menu-modal--remove-time-range-aria-label',
    defaultMessage: 'Remove {dayLabel} time range {index}',
  },
  addTimes: {
    id: 'sku-add-menu-modal--add-times',
    defaultMessage: 'Add times',
  },
  selectTimePlaceholder: {
    id: 'sku-add-menu-modal--select-time-placeholder',
    defaultMessage: 'Select time',
  },
  startLabel: {
    id: 'sku-add-menu-modal--start-label',
    defaultMessage: 'Start',
  },
  endLabel: {
    id: 'sku-add-menu-modal--end-label',
    defaultMessage: 'End',
  },
  editMenuTitle: {
    id: 'sku-edit-menu-modal--title',
    defaultMessage: 'Edit {menuName} Menu',
  },
  viewMenuTitle: {
    id: 'sku-view-menu-modal--title',
    defaultMessage: 'View {menuName}',
  },
  saveButton: {
    id: 'sku-edit-menu-modal--save',
    defaultMessage: 'Save',
  },
  availableLabel: {
    id: 'sku-menu-modal--available',
    defaultMessage: 'Available',
  },
  unavailableLabel: {
    id: 'sku-menu-modal--unavailable',
    defaultMessage: 'Unavailable',
  },
});

export default messages;
